import { render, staticRenderFns } from "./add-group-type.vue?vue&type=template&id=e821902e&scoped=true&"
import script from "./add-group-type.vue?vue&type=script&lang=js&"
export * from "./add-group-type.vue?vue&type=script&lang=js&"
import style0 from "./add-group-type.vue?vue&type=style&index=0&id=e821902e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e821902e",
  null
  
)

export default component.exports